import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => {
  return {
    input: {
      width: '100%',
      marginTop: theme.spacing(6),
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    labelSize: {
      fontSize: 25,
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
        marginTop: theme.spacing(1),
      },
    },
    inputSize: {
      fontSize: 28,
      minHeight: 70,
      paddingTop: theme.spacing(1),
    },
    root: {
      marginTop: 0,
      fontSize: 15,
    },
    helperTextContainer: {
      marginTop: theme.spacing(0.5),
    },
  };
};

class PasswordTextField extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    password: PropTypes.string,
    label: PropTypes.string,
    validPasswordCallback: PropTypes.func.isRequired,
    passwordCallback: PropTypes.func.isRequired,
  };
  state = {
    focused: false,
    hasBlurredOnce: false,
  };

  componentDidUpdate() {
    const { password } = this.props;
    if (password.length === 0) {
      this.setBlurredFalse();
    }
    this.props.validPasswordCallback(this.displayErrors().length === 0 && password.length !== 0);
  }

  setBlurredFalse = () => {
    this.setState({ hasBlurredOnce: false });
  };

  handlePasswordChange = event => {
    this.props.passwordCallback(event.target.value);
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  toggleBlurredOnce = () => {
    this.setState({ hasBlurredOnce: true });
  };

  displayErrors = () => {
    let errorMessages = [];
    const errors = [
      {
        msg: 'Please add at least one lowercase letter.',
        regex: /[a-z]/,
      },
      {
        msg: 'Please add at least one capital letter.',
        regex: /[A-Z]/,
      },
      {
        msg: 'Please add at least one number.',
        regex: /[0-9]/,
      },
      {
        msg: 'Please add at least eight characters',
        regex: /.{8,}/g,
      },
    ];
    for (let i = 0; i < errors.length; i++) {
      let error = errors[i];
      if (error.regex.test(this.props.password) === false && this.props.password.length > 0) {
        errorMessages.push(error.msg);
      }
    }
    return errorMessages;
  };

  displayTextfieldErrorOne = () => {
    if (this.props.password.length === 0 || this.displayErrors().length === 0) {
      return true;
    } else {
      return false;
    }
  };

  displayErrorText = () => {
    const { classes } = this.props;
    const errors = this.displayErrors();
    const blank = '';
    if (this.state.hasBlurredOnce && this.props.password.length > 0) {
      return (
        <div className={classes.helperTextContainer}>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[0]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[1]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[2]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[3]}
          </FormHelperText>
        </div>
      );
    } else {
      return (
        <div className={classes.helperTextContainer}>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
        </div>
      );
    }
  };
  isInvalidPassword = () => {
    return (
      this.displayErrors().length !== 0 &&
      this.props.password.length !== 0 &&
      this.state.hasBlurredOnce
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <FormControl className={classes.input}>
          <InputLabel className={classes.labelSize}>{this.props.label}</InputLabel>
          <Input
            className={classes.inputSize}
            type="password"
            onChange={this.handlePasswordChange}
            value={this.props.password}
            onFocus={this.onFocus}
            onBlur={this.toggleBlurredOnce}
            error={this.isInvalidPassword()}
          />
        </FormControl>
        {this.displayErrorText()}
      </div>
    );
  }
}

export default withStyles(styles)(PasswordTextField);
